module.exports = __webpack_public_path__ + "img/logo-2.77f2d56a.png";